<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForPaidPassengersMasterForm
        ref="feesForPaidPassengersMasterForm"
        v-model="feesForPaidPassengersMasterFormModel"
        label-width="10em"
        formMode="edit"
        :editDisabledMode="editDisabledMode"
        tableType="PAID_PASSENGERS"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForPaidPassengersMasterForm from '@/components/organisms/dialog/feeMaster/FeesForPaidPassengersMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForPaidPassengersMasterForm,
    EditDialogFooter
  },
  mixins: [
  ],
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForPaidPassengersMasterFormModel: {
        // billing_ym: this.getDefaultBillingYm(),
        charge_year: undefined,
        route_code: undefined,
        jet_type: undefined,
        paid_type: undefined,
        charge: undefined,
        max_passengers_rate: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForPaidPassengersMasterFormModel.regist_type === '1' || parseInt(this.feesForPaidPassengersMasterFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForPaidPassengersMasterForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-paid-passengers-master', this.feesForPaidPassengersMasterFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          // this.$emit('refresh', this.feesForPaidPassengersMasterFormModel.billing_ym)
          this.$emit('refresh', this.feesForPaidPassengersMasterFormModel.charge_year)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      // const trimItem = ['bill_to_code', 'departure_airport_code']
      this.$nextTick(() => {
        this.$refs.feesForPaidPassengersMasterForm.clearFields()
        Object.keys(this.feesForPaidPassengersMasterFormModel)
          .forEach((x) => {
            // if (trimItem.includes(x)) {
            //   this.currentRow[x] = this.currentRow[x].trimEnd()
            // }
            this.$set(this.feesForPaidPassengersMasterFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
